var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChalkboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M568 464H544V56C544 42.781 533.219 32 520 32H56C42.781 32 32 42.781 32 56V464H8C3.594 464 0 467.594 0 472S3.594 480 8 480H568C572.406 480 576 476.406 576 472S572.406 464 568 464ZM272 464V400H432V464H272ZM432 384H272C263.164 384 256 391.164 256 400V464H48V56C48 51.594 51.594 48 56 48H520C524.406 48 528 51.594 528 56V464H448V400C448 391.164 440.836 384 432 384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalkboard);
export default __webpack_public_path__ + "static/media/chalkboard.8b7f101228ddae36047111db5edebcf9.svg";
export { ForwardRef as ReactComponent };